import {
	RV_REMOVE_PROPERTY,
	RV_RESET,
	RV_UPDATE_DOCS,
	RV_UPDATE_PROPERTY,
	RV_UPDATE_REASON,
	UPDATE_RV_ENV,
	UPDATE_RV_PROPERTIES,
	UPDATE_RV_SEARCH_OPTIONS,
} from "./core/actions";
import { Actions } from "@my-dld/actions";
import { defRVContext, IRVContext } from "./RVContext";
import { Property } from "./api/Property";
import { AnyAction } from "redux";

const defaultState: IRVContext = defRVContext;
export { defaultState as DefaultState };

export function RVReducer( state = defaultState, action: AnyAction ) {
	let ps = state.properties;
	let p: Property = action.payload;

	switch ( action.type ) {
		case UPDATE_RV_ENV:
			return { ...state, env: action.payload };

		case UPDATE_RV_PROPERTIES:
			return { ...state, properties: action.payload };

		case UPDATE_RV_SEARCH_OPTIONS:
			return { ...state, searchOption: action.payload };
		case RV_REMOVE_PROPERTY:
			if ( p && ps && ps.length > 0 ) {
				let nep = ps.filter( x => !( x.PropertyId === p.PropertyId && x.PropertyTypeId === p.PropertyTypeId ) );
				let update: Partial<IRVContext> = {
					properties: nep,
				};
				if ( nep.length === 0 ) {
					update.searchOption = undefined;
				}
				return { ...state, ...update };
			}
			return state;
		case RV_UPDATE_PROPERTY:
			if ( p && ps && ps.length > 0 ) {
				let ix = ps.findIndex( x => ( x.PropertyId === p.PropertyId && x.PropertyTypeId === p.PropertyTypeId ) );
				let update: Partial<IRVContext> = {};
				if ( ix > -1 ) {
					ps[ ix ] = p;
					update.properties = [ ...ps ];
				}
				return { ...state, ...update };
			}
			return state;
		case RV_UPDATE_REASON:
			return {
				...state,
				reason: action.payload.id,
				comment: action.payload.comment,
			};
		case  RV_UPDATE_DOCS:
			return {
				...state,
				documents: action.payload,
			};
		case RV_RESET:
			return {
				...defaultState,
			};
		case Actions.USER_LOGGED_OUT:
			return {
				...defaultState,
			};
		default:
			return state;
	}
}

declare module "@my-dld/reducers/store" {
	interface IStore {
		RValuation: IRVContext,
	}
}
